import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDomain } from 'src/bff';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';
import { SelectExtended, InputWrapper } from '.';
import { SelectExtendedList } from './CarlineSelect';
import { InputError, TextInputExtended } from './inputs';
import { store, useIsComerciales } from 'src/feature-app';
export interface CountryProps {
  formToken?: string;
  paddingTop?: string;
  paddingBottom?: string;
}

export function Country(props: CountryProps) {
  const { formToken } = props;
  const { register, errors } = useFormContext();
  const [errorCountry, setErrorCountry] = useState(false);
  const { formData, formInfo, domainsInfo } = useSelector((state: OneFormState) => state);
  const { fields } = formData;
  const { error } = useOneFormContext();
  const [list, setList] = useState<SelectExtendedList[]>(null);
  const dispatch = useDispatch();
  const [country, setCountry] = useState(null);
  const defaultCountryCode = 'ES';
  const defaultCountryName = 'España';

  const formatCountryExtendedList = (name: string, code: string): SelectExtendedList => {
    return {
      code,
      name,
      key: code,
    };
  };

  const isComerciales = useIsComerciales() ? 'true' : 'false';
  const domain = 'COUNTRY';
  const token = formToken ? formToken : isComerciales ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM';

  const requestContries = async () => {
    const response = await fetchDomain(token, domain);
    const options = response.content
    .filter(att => att.attributes.find(attr => attr.name == 'IS_LCV')?.value == isComerciales)
    .map((att) => {
      const code = att.attributes.find(attr => attr.name == 'CODIGO')?.value;
      const name = att.attributes.find(attr => attr.name == 'PAIS_CASTELLANO')?.value;
      return formatCountryExtendedList(name, code);
    });
    setList(options);
	setFirstSelected();
	dispatch({ type: 'ADD_DOMAIN', payload: { [token]: { [domain]: options } } });
  };

  useEffect(() => {
	if(domainsInfo[token] && domainsInfo[token][domain]) {
		setList(domainsInfo[token][domain]);
		setFirstSelected();
	}
	else {
		requestContries();
	}
  }, []);

  const setFirstSelected = () => {
	if(fields.countryCode && fields.countryName) {
		updateCountryValues(fields.countryCode, fields.countryName);
	}
	else if(defaultCountryCode && defaultCountryName) {
		updateCountryValues(defaultCountryCode, defaultCountryName);
	}
  };

  useEffect(() => {
    if (error) {
      !country ? setErrorCountry(true) : setErrorCountry(false);
    }
  }, [error]);

  useEffect(() => {
    if (errors.country) {
      setErrorCountry(true);
    } else {
      setErrorCountry(false);
    }
  }, [errors]);

  function handleChangeCountry(event: any) {
    const newCountryValue = event.currentTarget.value;

    const newCountry = list.find((country) => country.name === newCountryValue);
    if (newCountry) {
      updateCountryValues(newCountry.code, newCountry.name);
    }
    else if (newCountryValue !== '') {
      setErrorCountry(false);
    }
  }

  const updateCountryValues = (countryCode: string, countryName: string) => {
	setCountry(countryName);
    dispatch({ type: 'UPDATE_FIELDS', payload: { countryCode, countryName } });
	dispatch({ type: 'UPDATE_LITERAL_FIELDS_STEPS', payload: { country : countryName } });
  };

  return (
    <InputWrapper className="country-select-wrapper" notALayer={formInfo.notALayer} paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}>
      {list ? (
        <>
          <SelectExtended
            name="country"
            label="Selecciona tu país"
            value={country ? country : ''}
            required
            options={list}
            handleChange={handleChangeCountry}
            onClick={() => { }}
            updateFields
            setOption={setCountry}
            isRequired={true}
          />
        </>
      ) : (
        <TextInputExtended
          innerRef={register({
            required: {
              value: true,
              message: 'Requerido',
            },
          })}
          name="country"
          label="Modelo"
          isFloating
        />
      )}
      {errorCountry ? <InputError className="input-error">Este campo es obligatorio</InputError> : null}
      {<input name="country" hidden value={country ? country : ''} />}
    </InputWrapper>
  );
}
